module.exports = __webpack_public_path__ + "img/footer1.93eb566a.png";